import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
const NotFound = () => {
  const navigate = useNavigate();

  return(
    <Result
    status="403"
    title="看啥呢？"
    subTitle="网页出错了，快跑吧！！！"
    extra={<Button type="primary" onClick={e=> {navigate(-1)}}>一键跑路</Button>}
    />
  );
  
};
export default NotFound;